import $ from 'jquery';

import statesData from '../scripts/statesData';

$.addInit(function(context){
	var base = '.b-deliveryCalc';
	$(base, context).each(function(){
		var component = $(this);
		var boxContent = component.find('.b-form-boxContent');

		var southWest = L.latLng(-85, -180),
		northEast = L.latLng(85, 180),
		bounds = L.latLngBounds(southWest, northEast);

		var map = L.map('map', {
			center: [27.25, 29.44],
			zoom: 2,
			maxBounds: bounds,
			minZoom: 2,
			scrollWheelZoom: false,
			doubleClickZoom: false,
			dragAndDrop: false,
			zoomControl: false,
			attributionControl: false,
		});

		var info = L.control();

		info.onAdd = function (map) {
			this._div = L.DomUtil.create('div', 'info');
			this.update();
			return this._div;
		};

		var select = component.find('.i-select-country');

		info.update = function (props) {
			boxContent.trigger('setAddress', props);

			if (props != undefined) {
				select.val(props)
				select.trigger('change');
			}
		};

		info.addTo(map);

		function style(feature) {
			return {
				weight: 2,
				opacity: 1,
				// color: feature.nid == 105 ? '#fa9f1a' : 'white',
				color: 'white',
				// interactive: feature.nid == 105 ? false : false,
				dashArray: 0,
				fillOpacity: 1,
			};
		}

		function highlightFeature(e) {
			geojson.resetStyle()
			var layer = e.target;

			if (layer.feature.nid != 105) {
				layer.setStyle({
					weight: 0,
					color: '#fa9f1a',
				});

				if (!L.Browser.ie && !L.Browser.opera && !L.Browser.edge) {
					layer.bringToFront();
				}

				info.update(layer.feature.nid);
			}
		}

		var geojson;

		function onEachFeature(feature, layer) {
			layer.on({
				click: highlightFeature
			});
		}

		geojson = L.geoJson(statesData, {
			style: style,
			onEachFeature: onEachFeature
		}).addTo(map);

		geojson.getLayers().find(ele => ele.feature.nid == component.find(base + '-map').data('active')).setStyle({
			color: '#fa9f1a'
		});

		

		boxContent.on('setAddress', function (e, props) {
			if (props == $(this).data('nid')) {
				boxContent.prop('hidden', true);
				$(this).prop('hidden', false);
			}
		});

		select.on('change', function(e) {
			var selectValue = $(this).val();

			boxContent.trigger('setAddress', selectValue);

			geojson.resetStyle();
			geojson.getLayers().find(ele => ele.feature.nid == selectValue).setStyle({
				color: '#fa9f1a'
			});
		});
	});
});
